<template>
    <div
        class="author"
    >
        <div class="author__head">
            <login
                    v-if="!$vuetify.breakpoint.xsOnly"
                    v-model="value.login"
            ></login>
            <follow
                v-if="!value.is_my_diary"
                v-model="value.is_follow_user"
                :userId="value.user_id"
                @input="v => $emit('change-follow', v)"
                action-create="createFollow"
                action-delete="deleteFollow"
            ></follow>
        </div>
        <div
            class="author__project-name"
            :title="$t('msg.projectName')"
        >{{value.project_name}}</div>
        <div class="author__progress">
            {{ value.project_complete_percent | numFormat('0,0.0') }} %
            <v-progress-linear
                :value="value.project_complete_percent"
            ></v-progress-linear>
        </div>
    </div>
</template>

<script>
import Login from "../../ui/Login";
import Follow from "../../ui/Follow";

export default {
    components: {Login, Follow},
    props: {
        value: Object
    },
    data() {
        return {
            localValue: this.value
        }
    },
    watch: {
        localValue: {
            handler(v) {
                this.$emit('update', v);
            },
            deep: true
        }
    }
}
</script>

<style lang="scss">
.author {
    .author__head {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .author__project-name {
        font-size: 13px;
        margin: 7px 0 10px 0;
    }
}
</style>